import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpContextToken } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';

/** Opt-out for fire-and-forget probes (e.g. the Connections nav gate): a 401
 *  from a probe must fail the PROBE, not sign the user out of the whole hub.
 *  Probes hit secondary API hosts (api.connectors.*) whose authorizer issues
 *  can otherwise force a logout on every page load. */
export const SKIP_SESSION_EXPIRY_REDIRECT = new HttpContextToken<boolean>(() => false);

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private auth: AuthenticationService, private router: Router) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      catchError((err: { status?: number; error?: { message?: string; statusCode?: string }; statusText?: string }) => {
        if (request.context.get(SKIP_SESSION_EXPIRY_REDIRECT)) {
          return throwError(() => ({ message: err.error?.message || err.statusText || 'Something went wrong.', status: err.status }));
        }
        if (err.status === 401 || (err.status === 403 && (err.error?.statusCode === 'unauthorized' || this.auth.isBackendTokenExpired()))) {
          this.auth.logout();
          this.router.navigate(['/login'], { queryParams: { expired: true } });
          return throwError(() => ({ message: 'Session expired. Please sign in again.', status: err.status }));
        }
        return throwError(() => ({ message: err.error?.message || err.statusText || 'Something went wrong.', status: err.status }));
      })
    );
  }
}
